import type { FieldValues } from 'react-hook-form';
import type { ErrorNotificationMessage } from '../error-notification-types/error-notification-message';
import { ERROR_NOTIFICATION_TYPES } from '../error-notification-types/error-notification-type';
import type { ErrorNotificationDescriptor } from '../error-notification-types/error-notifications/error-notification-descriptor';

export function isErrorNotificationDescriptor<FormInput extends FieldValues | undefined>(
  error: ErrorNotificationMessage<FormInput | undefined>,
): error is ErrorNotificationDescriptor {
  return (error as ErrorNotificationDescriptor).type === ERROR_NOTIFICATION_TYPES.Descriptor;
}